import superagent from 'superagent';
import Networker from './Networker';

const PUSH_IMAGE_BUCKET = 'adrich-notification-images';
const PUSH_IMAGE_FOLDER = 'notification-images';
const PUSH_IMAGE_REGION = 'us-east-2';

function sanitizeFileName(name) {
  return String(name || 'image')
    .replace(/\s+/g, '_')
    .replace(/[^a-zA-Z0-9._-]/g, '');
}

export const fileUploaderAWS = async (file) => {
  if (!file) {
    throw new Error('No file provided');
  }

  const { name, type } = file;

  const fileName = `${Date.now()}_${sanitizeFileName(name)}`;
  const key = `${PUSH_IMAGE_FOLDER}/${fileName}`;

  const presignRes = await Networker.post({
    root: 'aws',
    inner: 'presigned',
    body: {
      folder: PUSH_IMAGE_FOLDER,
      file_name: fileName,
      bucket: PUSH_IMAGE_BUCKET,
      content_type: type,
    },
  });

  console.info('Presign URL response:', presignRes);

  const uploadUrl = presignRes?.body?.data;

  const publicUrl =
    presignRes?.body?.publicUrl ||
    `https://${PUSH_IMAGE_BUCKET}.s3.${PUSH_IMAGE_REGION}.amazonaws.com/${key}`;

  console.info('Presigned uploadUrl:', uploadUrl);
  console.info('Presigned publicUrl:', publicUrl);

  if (!uploadUrl) {
    throw new Error(`Failed to create AWS presigned upload URL. body=${JSON.stringify(presignRes?.body)}`);
  }

  const parsedUrl = new URL(uploadUrl);

  const signedMetaCacheControl = parsedUrl.searchParams.get('x-amz-meta-cache-control');
  const signedMetaExpires = parsedUrl.searchParams.get('x-amz-meta-expires');

  console.info('Signed metadata headers:', {
    signedMetaCacheControl,
    signedMetaExpires,
  });

  let request = superagent
    .put(uploadUrl)
    .set('Content-Type', type);

  if (signedMetaCacheControl) {
    request = request.set('x-amz-meta-cache-control', signedMetaCacheControl);
  }

  if (signedMetaExpires) {
    request = request.set('x-amz-meta-expires', signedMetaExpires);
  }

  try {
    await request.send(file);
  } catch (err) {
    console.error('S3 image upload failed:', err);
    console.error('S3 response status:', err?.status);
    console.error('S3 response text:', err?.response?.text);
    throw err;
  }

  return publicUrl;
};